<div *ngIf="cargado">
  <app-header
    [nombres]="nombres"
    [apellidos]="apellidos"
    [colegio]="colegio"
    [genero]="genero"
    [id]="mainUserUidDb"
    [rol]="datosUsuario.rol"
  ></app-header>

  <div class="maingrid">
    <div>
      <app-menu
        [uidb]="mainUserUidDb"
        [uid]="userUid"
        [avatar]="useravatar"
        [rolUser]="rolUsuario"
      ></app-menu>
    </div>

    <div>
      <!-- content -->
      <div class="contenido">
        <section class="basicbox2 horojo medium martop misclases">
          <div id="flexContainer">
            <article>
              <div class="acciones">
                <div class="magisterio" (click)="irMagisterio()">
                  <div class="left">
                    <img src="assets/img/tools/magisnet.jpg" alt="" />
                  </div>
                  <div class="right">
                    <p>Periódico <br> Magisterio</p>
                  </div>
                </div>

                <!-- <button
                    class="button medium center separado"
                    routerLink="/externo/appsint/the-campus.online\jornadas-meeting-your-future-2024-2025-academica"
                    title="Meeting your future"
                  >
                    Acceso a Meeting your future
                  </button> -->

                <!-- <a (click)="irMagisterio()" title="Magisterio">
                  <img class="magisnet" src="assets/img/tools/magisnet.jpg" />
                </a> -->
              </div>
            </article>

            <!-- <footer>
              <a
                   routerLink="/externo/no-accesible/"
               
                class="button medium center"
              >
                {{ "dashboard.vertodos" | translate }}
              </a>
            </footer> -->
          </div>
        </section>

        <section class="contentwrapper">
          <!-- <div class="breadcrumb">
            <div id="container">
              <ng-container *ngFor="let bread of breadcrumb" id="container">
                <div routerLink="{{ bread.link }}" id="migas">
                  <div id="migasF">
                    <div id="nameM" translate>
                      {{ bread.nombre }}
                    </div>
                    <div>
                      <span
                        class="close"
                        (click)="RemoveBreadcrumb(bread.nombre)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="11.513"
                          height="8.063"
                          viewBox="0 0 11.513 8.063"
                        >
                          <g
                            id="Grupo_9481"
                            data-name="Grupo 9481"
                            transform="translate(-5.602 -5.601)"
                          >
                            <path
                              id="Trazado_9279"
                              data-name="Trazado 9279"
                              d="M17.115,9.633Z"
                              fill="#fff"
                            />
                            <path
                              id="Trazado_9280"
                              data-name="Trazado 9280"
                              d="M16.889,9.164a.575.575,0,0,0-.814,0l0,0-3.045,3.05L9.982,9.164a.578.578,0,0,0-.817.817l3.05,3.045-3.05,3.045a.578.578,0,0,0,.817.817l3.045-3.05,3.045,3.05a.578.578,0,0,0,.817-.817l-3.05-3.045,3.05-3.045a.575.575,0,0,0,0-.814Z"
                              transform="translate(-3.394 -3.393)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div> -->

          <!-- contenedor cambiante -->
          <section class="changecontent">
            <router-outlet> </router-outlet>
          </section>
          <!-- /contenedor cambiante -->
        </section>
      </div>
      <!-- /content -->
    </div>
  </div>
</div>

<div *ngIf="loading" class="fullscreen-spinner">
  <div class="spinner"></div>
</div>
